import { Box, Container } from "@mui/material";
import Page from "components/Page";
import { ReactElement, ReactNode } from "react";
import useAppTheme from "hooks/useAppTheme";
import { withAuthenticationRequired } from "@auth0/auth0-react";

export type PageHeight = "100%" | 'auto';

export interface PageWithBreadcrumbsLayoutProps {
  action?: ReactNode;
  children?: ReactElement;
  heading: string;
  moreLink?: string | Array<string>;
  height?: PageHeight
}

const PageLayout = function ({ heading, action, children, height }: PageWithBreadcrumbsLayoutProps) {
  const { themeStretch } = useAppTheme();

  return (
    <Page title={heading} appName={process.env.REACT_APP_CLIENT_NAME!}>
      <Container maxWidth={themeStretch ? false : "lg"} sx={{ height: height ?? '100%' }}>
        {action && (
          <Box sx={{ mb: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
              <Box sx={{ flexShrink: 0, maxWidth: '100%' }}>{action}</Box>
            </Box>
          </Box>
        )}
        {children}
      </Container>
    </Page>
  );
};

export const AuthPageLayout = withAuthenticationRequired(PageLayout);
